import { bettingSplitsIndex } from '~/search-domain/indexes';
import { buildBettingSplitsQuery } from '~/search-domain/pipelines/betting-splits/build-query';
import {
  getBettingSplitsBaseFilters,
  getBettingSplitsFacetAttributes,
  getBettingSplitsSearchSettings,
  getBettingSplitsSorting,
} from '~/search-domain/pipelines/betting-splits/query-config';
import { transformBettingSplitsResponse } from '~/search-domain/pipelines/betting-splits/transform-response';
import { type BettingSplitsESResultBody } from '~/search-domain/pipelines/betting-splits/types';
import { type SearchPipelineDefinition, type SearchUiState } from '~/search-domain/types';

const resolveBettingSplitsSorting = (context: Parameters<typeof getBettingSplitsSorting>[0]) =>
  getBettingSplitsSorting(context);

export const bettingSplitsPipelineDefinition: SearchPipelineDefinition<SearchUiState, BettingSplitsESResultBody> = {
  buildSearchRequest: buildBettingSplitsQuery,
  facetAttributes: context => getBettingSplitsFacetAttributes(context),
  getBaseFilters: context => getBettingSplitsBaseFilters(context),
  getSearchUiConfig: context => ({
    searchAttributes: getBettingSplitsSearchSettings().search ?? [],
    sorting: () => resolveBettingSplitsSorting(context),
  }),
  getSorting: context => getBettingSplitsSorting(context),
  id: bettingSplitsIndex,
  searchSettings: () => getBettingSplitsSearchSettings(),
  transformResponse: transformBettingSplitsResponse,
};
